import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { ILiveStreamFormValues } from './LiveStreamForm';
import { FormDateField } from '~/components/atoms/fields/DateField';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type ILiveStreamFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<ILiveStreamFormValues>;
  mode: IFormMode;
};

export const LiveStreamFormMainSection: React.FC<
  ILiveStreamFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('common.name')} required>
        <FormField
          as={TextInputField}
          forwardError
          control={form.control}
          name="name"
        />
      </Labeled>

      <Labeled
        label={t('LiveStreamFormMainSection.fields.startDateTime.label')}
        required
      >
        <FormDateField name="startDateTime" control={form.control} />
      </Labeled>
    </FormSection>
  );
};
